import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from './ui/alert-dialog';

const RecurringDeleteDialog = ({ open, onOpenChange, onConfirm, isRecurring }) => {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent className="bg-[#1a1a1b] border-gray-800 text-white">
                <AlertDialogHeader>
                    <AlertDialogTitle>İdman Silme İşlemi</AlertDialogTitle>
                    <AlertDialogDescription className="text-gray-400">
                        {isRecurring ? 'Bu tekrarlayan bir idman programı. Sadece bu idmanı mı yoksa tüm programı mı silmek istersiniz?' : 'Bu etkinliği silmek istediğinizden emin misiniz?'}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="sm:justify-start gap-2">
                    <AlertDialogCancel onClick={() => onOpenChange(false)} className="border-gray-700 bg-transparent text-gray-300 hover:bg-gray-800">
                        İptal
                    </AlertDialogCancel>

                    {isRecurring ? (
                        <>
                            <AlertDialogAction
                                onClick={() => onConfirm('instance')}
                                className="bg-red-600 hover:bg-red-700 text-white"
                            >
                                Sadece Bu İdmanı Sil
                            </AlertDialogAction>
                            <AlertDialogAction
                                onClick={() => onConfirm('series')}
                                className="bg-red-900/50 hover:bg-red-900 text-red-200 border border-red-800"
                            >
                                Tüm Seriyi Sil
                            </AlertDialogAction>
                        </>
                    ) : (
                        <AlertDialogAction
                            onClick={() => onConfirm('single')}
                            className="bg-red-600 hover:bg-red-700 text-white"
                        >
                            Etkinliği Sil
                        </AlertDialogAction>
                    )}
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default RecurringDeleteDialog;
